import { WEBINAR_HOST_GUIDE } from "./webinar-host-guide";
import { MEETING_RECORDER_GUIDE } from "./meeting-recorder";
import { WEBCASTS_USER_MANUAL } from "./webcasts-user-manual";
import { ZOOM_RECORDINGS_GUIDE } from "./zoom-recordings-guide";
import { LANDING_PAGES_GUIDE } from "./landing-pages-guide";
import { NEWSLETTERS_GUIDE } from "./newsletters-guide";
import { CONTENT_BLOCKS_GUIDE } from "./content-blocks-guide";
import { KANBAN_GUIDE } from "./kanban-guide";
import { AUTHENTICATOR_GUIDE } from "./authenticator-guide";
import { WHATS_NEW_GUIDE } from "./whats-new";

export const ALL_GUIDES = [
  WHATS_NEW_GUIDE,
  NEWSLETTERS_GUIDE,
  CONTENT_BLOCKS_GUIDE,
  WEBCASTS_USER_MANUAL,
  WEBINAR_HOST_GUIDE,
  MEETING_RECORDER_GUIDE,
  ZOOM_RECORDINGS_GUIDE,
  LANDING_PAGES_GUIDE,
  KANBAN_GUIDE,
  AUTHENTICATOR_GUIDE,
];

export function getGuideById(id) {
  return ALL_GUIDES.find((g) => g.id === id) || null;
}
